<template>
  <path d="M3.83268 13H5.49935V17.1666H15.4993V3.83329H5.49935V7.99996H3.83268V2.99996C3.83268 2.77895 3.92048 2.56698 4.07676 2.4107C4.23304 2.25442 4.445 2.16663 4.66602 2.16663H16.3327C16.5537 2.16663 16.7657 2.25442 16.9219 2.4107C17.0782 2.56698 17.166 2.77895 17.166 2.99996V18C17.166 18.221 17.0782 18.4329 16.9219 18.5892C16.7657 18.7455 16.5537 18.8333 16.3327 18.8333H4.66602C4.445 18.8333 4.23304 18.7455 4.07676 18.5892C3.92048 18.4329 3.83268 18.221 3.83268 18V13ZM8.83268 9.66663V7.16663L12.9993 10.5L8.83268 13.8333V11.3333H2.16602V9.66663H8.83268Z" fill="white"/>
</template>

<script>
    export default {
        name: 'icon-door'
    }
</script>